import { IDeliveriesSettings } from "./ideliveries-settings";

export class DeliveriesSettings implements IDeliveriesSettings {
	//#region PROPERTIES

	/** @implements */
	public disableTutorial: boolean;

	//#endregion

	//#region METHODS

	constructor(poData?: IDeliveriesSettings) {
		this.disableTutorial = poData?.disableTutorial ?? false;
	}

	/** Retourne `true` si l'instance en paramètre est égale à l'instance courante, `false` sinon.
	 * @param poValue Instance à comparer.
	 */
	public equals(poValue?: IDeliveriesSettings): boolean {
		return this === poValue || this.disableTutorial === poValue?.disableTutorial;
	}

	//#endregion METHODS
}
